import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { MiscLayout } from '../Layout';

function MiscTab(props) {
    var currentUser = props.oidc.user;
        const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='14B99EB7-1C0F-4B98-BE47-EFEAEE2B7670'
                layoutName='OMSalesOrderDataEntryMiscForm'
                defaultFormSchema={MiscLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.onFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(MiscTab);
